import React from "react";
import TruncateText from "./TruncateText";
import { Link } from "react-router-dom";
import PaintSVG from "./PaintSVG";


export const  Products = ({lang,products,animation}) => {

    


  return (
   
      <div className={`  w-full `} >
         
         <div className={`translate-y-[150px]  ${animation ? `transition-all delay-500 duration-200  opacity-[1]` :  'transition-all  duration-200 opacity-[0]'  }   w-full flex`}>
       <div className="m-auto animate-spin">

       <svg aria-hidden="true" className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-red-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>
 </div> 
 </div>

 <div className={`translate-y-[150px]  ${!animation && products.length === 0 ? `transition-all delay-500 duration-200  opacity-[1]` :  'transition-all  duration-200 opacity-[0]'  }   w-full flex`}>
     
     <p className="m-auto"> {lang === 'en' ? 'Ther is no products' : 'لا يوجد اي منتج '} </p>
              </div>
          <div className= {`min-h-[300px]   ${animation ? `transition-all  duration-500 ${lang === 'en' ? '-translate-x-[100%]' :'translate-x-[100%]'} opacity-[0]` :  'transition-all  duration-500 translate-x-[0] opacity-[1]'  }  w-full  p-1 grid grid-cols-[repeat(auto-fill,minmax(150px,1fr))] md:grid-cols-[repeat(auto-fill,minmax(200px,1fr))] lg:grid-cols-[repeat(auto-fill,minmax(250px,1fr))] xl:grid-cols-[repeat(auto-fill,minmax(300px,1fr))] gap-2 `}>
            {products.map((item, index) => (
              <Link
              to={`/Product/${item.id}`}
                key={index}
                className="group hover:bg-white hover:shadow-lg p-1 relative mx-auto flex flex-col rounded-[7px]  bg-[#F4F4F4] h-[200px] w-[150px] min-h-[200px] min-w-[150px]  
                lg:w-[250px] lg:h-[350px] xl:w-[300px] xl:h-[450px] md:h-[250px] md:w-[200px]
                lg:min-w-[250px] lg:min-h-[320px] xl:min-w-[300px] xl:min-h-[370px] md:min-h-[250px] md:min-w-[200px] "
              >
               {Number(item.category) === 13 ?

       <div className="  w-[140px] h-[140px] lg:w-[240px] lg:h-[240px] xl:w-[290px] xl:h-[290px]  md:h-[190px] md:w-[190px]">
       <PaintSVG  color={item.color} />
           </div>
            



               :
                <img
                 src={`https://demo.future-swift.com/products/${item.src}`}
                  alt={`Product ${index + 1}`}
                  className="object-contain m-auto w-[140px] max-h-[140px] lg:w-[240px] lg:max-h-[240px] xl:w-[290px] xl:max-h-[290px]  md:h-[190px] md:w-[190px]"
                />}
           
              <div className="flex max-w-full  h-[3px] w-full" />
              <div className="m-auto  w-[140px]  h-[50px]  lg:w-[240px] lg:h-[70px] xl:w-[290px] xl:h-[70px] md:h-[50px] md:w-[190px]">
               
               <h3 style={{fontFamily:'CairoSemiBold'}} className={`${lang === 'en' ? "text-left" : "text-right"} w-full text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px] xl:text-[18px]`}> {lang === 'en' ? TruncateText(item.title_en,20) :TruncateText(item.title,20)  }</h3>
               <div className="group-hover:block    hidden  flex my-[1px] max-w-full bg-zinc-300 h-[2px] w-full" />
               <p style={{fontFamily:'CairoMedium'}} className={` ${lang === 'en' ? "text-left" : "text-right"} text-[9px] sm:text-[10px] md:text-[12px] lg:text-[14px] xl:text-[16px]`}>{lang === 'en' ? TruncateText( item.description_en, 50)  :TruncateText( item.description, 60)}</p>
              </div>


              </Link>
            ))}
          </div>

          
      

        </div>
    

   
  );
}
